import {FC} from 'react'
import filter from 'lodash/filter'
import Card from '_core/components/Card'
import ShippingLineItem from './ShippingLineItem'
import {fulfillmentStatusTypes} from 'app/constant'

type Props = {
  items: any[]
  fulfillmentStatus?: string
}

const ShippingItems: FC<Props> = ({items, fulfillmentStatus}) => {
  return (
    <Card title='Items' className='card card-xl-stretch mb-5 mb-xl-8'>
      <div className='table-responsive'>
        <table
          id='tableShipping'
          className='table table-row-dashed table-row-gray-300 align-middle gs-0'
        >
          <tbody>
            {filter(items, (item: any) => item.fulfillableQuantity > 0).map((item, index) => (
              <ShippingLineItem
                key={index}
                item={item}
                disabled={fulfillmentStatusTypes.readyToFulfill === fulfillmentStatus}
              />
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  )
}

export default ShippingItems
